import ReactSelect from 'react-select';

import styled, { css } from 'styled-components';

import { pickColor } from 'themes/helpers/pickColor';
import { FontScale, getFontScale } from 'themes/mixins/getFontScale';
import { mediaMinWidth } from 'themes/mixins/mediaQueries';

export type StyledSelectProps = {
  scale?: FontScale;
};

const Container = styled.div<StyledSelectProps>`
  position: relative;

  display: flex;
  flex-direction: column;

  ${({ scale }) => scale && getFontScale(scale)}
`;

const Label = styled.label`
  height: 1.9rem;
  margin: 1rem 0;

  text-transform: uppercase;
  font-size: 0.9rem;
  font-family: 'LFT Zeno', sans-serif;
  font-weight: 600;
  letter-spacing: 0.1rem;

  color: ${pickColor('grayLabel')};

  ${mediaMinWidth.md(css`
    letter-spacing: 0;
  `)}
`;

const Select = styled(ReactSelect)`
  width: 100%;

  color: ${pickColor('grayDark')};
  text-transform: uppercase;
`;
export { Container, Label, Select };
